var StartCtrl = function () {

};

module.exports = StartCtrl;



// WEBPACK FOOTER //
// ./client/src/app/modules/start/StartCtrl.js